<template>
  <tr v-if="item.type === 0 " :data-group_id="group_name.id">
    <td
      class="group_res"
      @click="group_device('device_group/' + item.group_id)"
    >
      <span></span>
      <router-link
          class="group_name"
          :to="'/device_list?&group=' + group_name.id"
      >
        {{ `${group_name.name} (${item.online} / ${item.count})` }}
      </router-link>
      <span class="client" v-if="group_name.client_name">{{ translate('client.one') + ': ' + group_name.client_name }}</span>
      <span v-else></span>
    </td>
  </tr>
  <tr v-else-if="item.type ===-1">
    <td class="group_res">
      {{ translate('no_result') }}
    </td>
  </tr>
  <router-link v-else :to="go_to()" >
    <tr ref="device_item" class="link">
      <td v-if="checkbox"
        class="checkbox_table"
        :data-label="translate('check_it')"
      >
        <input
          v-model="item.checked"
          type="checkbox"
          @click.stop="check"
        >
      </td>
      <td
        :data-label="translate('status')"
        class="status"
      >
        <div class="status__wrap">
          <span
            v-if="item.status"
            class="mdi mdi-access-point problem_device online" >
          </span>
          <span
            v-if="!item.status"
            class="mdi mdi-access-point-off problem_device offline" >
          </span>
          <span
            v-if="backup && $store.getters.getPermissions.viewDeviceBackupStatus === true"
            class="mdi mdi-server-network problem_device backup"
          />
          <span
            v-if="blocked"
            class="mdi mdi-lock-alert problem_device blocked"
          />

          <router-link
              v-if="tariffication && $store.getters.getPermissions.viewCommerceData === true"
              :to="{ path: '/tariffication/tariffed_devices?fid=' + item.fid }"
              class="mdi mdi-currency-rub problem_device tariffication"
          />
        </div>

      </td>
      <td :data-label="translate('device.name')" class="device_name">
        <div>
          <p class="fz14">{{ item.fid }}</p>
          <p class="fz14">{{ item.service_id }}</p>
          <p class="fz12">{{ item.name2 }}</p>
          <p class="fz12" v-if="$store.getters.getPermissions.permissionGod">{{ item.name }}</p>
        </div>
      </td>

      <!-- Скрывать если смотрим на страницу с мобилки -->

      <td :data-label="translate('device.simcards')" class="sim_status" v-if="!mobile_version">
        <DeviceSimcards :simcards="item.simcards_uptime" />
      </td>
      <td :data-label="translate('device.place')" v-if="!mobile_version">
        {{ item.place }}
      </td>
      <td :data-label="translate('device.desc')" v-if="!mobile_version">
        {{ item.desc }}
      </td>
      <td :data-label="translate('IP')" v-if="!mobile_version && $store.getters.getPermissions.viewDeviceServerList === true">
        <div
          class="response_table"
          style="max-height: 60px"
        >
          <table>
            <tbody>
              <tr
                v-for="(server,key) in item.servers"
                :key="key"
              >
                <td
                  class="cstm_ellipsis"
                  :title="server_info(server)"
                >
                  {{ server.name }}
                </td><td
                  class="cstm_ellipsis"
                >
                  {{ server.device_ip }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </td>
      <td data-label="Uptime" ref="uptime" v-if="!mobile_version">
        <router-link class='link' :to="{ path: '/device/' + item.fid + '/stats' }">
            <!-- TODO: Сильно грузит страницу, нужно посмотреть как оптимизировать. -->
            <TimelineChart
              :trig_resize="resize"
              :chart-status="chartStatus"
              :item="item"
              :parent_width="parent_width()"
            />

        </router-link>
      </td>

    </tr>
  </router-link>
</template>
<script>
import SisIconStatus from 'components/UIComponents/Icon/SisIconStatus.vue'
import TimelineChart from './TimelineChart.vue'
import DeviceSimcards from 'components/UIComponents/DeviceSimcards/DeviceSimcards.vue'

export default {
  name: 'DeviceItem',
  components: {
    DeviceSimcards,
    TimelineChart,
    SisIconStatus
  },
  props: {
    item: Object,
    index: [Number, String],
    checkbox: {
      type: Boolean,
      default: true
    },
    mobile_version:{
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      status: false,
      chartStatus: false,
      resize: false
    }
  },
  computed: {
    device_name () {
      let name = "ID: " + this.item.fid +'<br>'+ this.item.name2
      if (this.$store.getters.getPermissions.permissionGod) {
        name += '<br>'
        name += this.item.name
      }
      return name
    },
    group_name () {
      return this.$store.getters.getDeviceGroupById(this.item.id)
    },
    blocked () {
      return this.item?.blocked_status === 1
    },
    backup () {
      if (this.item.backup) {
        return this.item.backup_serv + ':' + this.item.backup_ip
      }
      return false
    },
    tariffication(){
      return this.item?.tariffication?.status === 1
    }
  },
  activated () {
    this.$emit('mount', this.index)
  },
  mounted () {
    this.$emit('mount', this.index)
  },
  methods: {
    server_info(server){
      let text = ""
      text += `${server.name}\n${server.ip}`
      server.port ? text += `:${server.port}` : ''
      server.instance_name ? text += `\n${server.instance_name}` : ''
      return text
    },
    add_group_in_filter(group_id){
      this.$emit("add_group_in_filter",group_id)
    },
    parent_width(){
      return this.$refs.uptime ? this.$refs.uptime.clientWidth : 100
    },
    group_device(url){
      this.$router.push(url)
    },
    link_sim(link){
      this.$router.push(link)
    },
    check () {
      this.$emit('check', !this.item.checked, this.item)
    },
    cntx_menu (e) {
      this.$emit('contextmenu', e, this.item)
    },
    go_to () {
      return {path: '/device/' + this.item.fid?.trim()}
    },
    ready () {
      this.$emit('ready', this.index)
    }
  }
}
</script>

<style lang="scss" scoped>
  .link{
    margin-top: -1px;
    vertical-align: middle;
    &:hover{
      background-color: #f1f1f1;
      color: black;
    }
  }
  .device_name{
    p{
      margin: 0;
    }
    .fz12{
      font-size: 12px;
    }
    .fz14{
      font-size: 14px;
    }
  }
  .status{
    &__wrap{
      display: flex;
      align-items: center;
      justify-content: center;
      .problem_device {
        font-size: 22px;
        line-height: 100%;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        &.online{
          color: #15ab00;
        }
        &.backup{
          color: #ffbb40;
        }
        &.blocked{
          color: #ff4040;
        }
        &.tariffication{
          color: #3f93d3;
        }
      }
    }
  }

  .group_res{
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    span{
      min-width: 250px;
    }
    .client{
      text-align: right;
    }
    &:hover{
      background-color: #d5d5d5
    }
  }
  .sim_status{
    width: 170px;
  }


</style>
